import moment from "moment";
import * as types from "../types";

export const getLiveSessions = () => ({
  type: types.GET_LIVE_SESSIONS,
  request: {
    url: "/sessions",
    method: "GET",
    params: {
      "q[program_event_start_at_lt]": moment().add(30, "minutes").format(),
      "q[program_event_end_at_gt]": moment().subtract(30, "minutes").format()
    }
  }
});

export const getPastSessions = ({ tags, profileId, page, perPage }) => {
  const request = {
    type: types.GET_PAST_SESSIONS,
    request: {
      url: "/sessions",
      method: "GET",
      params: {
        "q[program_event_end_at_lt]": moment().add(30, "minutes").format(),
        "q[tagged_with_all]": JSON.stringify(tags),
        "q[speakers_id_or_moderators_id_eq]": profileId,
        "q[s]": ["program_event_start_at asc", "title asc"],
        page,
        per_page: perPage
      }
    }
  };
  if (page && parseInt(page, 10) !== 1) {
    request.meta = {
      mutations: {
        [types.GET_PAST_SESSIONS]: (prevData, newData) => {
          if (newData.meta.current_page <= prevData.meta.current_page) return newData;
          return { ...newData, data: prevData.data.concat(newData.data) };
        }
      }
    };
  }

  return request;
};

export const getSession = ({ id }) => ({
  type: types.GET_SESSION,
  request: {
    url: `/sessions/${id}`,
    method: "GET"
  }
});

export const getSpeakerSessions = ({ profileId }) => ({
  type: types.GET_SPEAKER_SESSIONS,
  request: {
    url: "/sessions",
    method: "GET",
    params: {
      "q[session_speakers_profile_id_eq]": profileId
    }
  }
});
